// Generated by ReScript, PLEASE EDIT WITH CARE


function fromString(rewardType) {
  switch (rewardType) {
    case "2_wheeler" :
        return /* TwoWheeler */2;
    case "4_wheeler_hcv" :
        return /* HCV */1;
    case "4_wheeler_lcv" :
        return /* LCV */0;
    default:
      return /* HCV */1;
  }
}

export {
  fromString ,
  
}
/* No side effect */
